import {
    UPDATE_HYDRATION_LEVEL_UPDATING,
    UPDATE_HYDRATION_LEVEL_SUCCESS,
    UPDATE_HYDRATION_LEVEL_ERROR,
    FETCH_HYDRATION_DATA_FETCHING,
    FETCH_HYDRATION_DATA_SUCCESS,
    FETCH_HYDRATION_DATA_FAIL,
    UPDATE_HYDRATION_ALL_DATA_UPDATING,
    UPDATE_HYDRATION_ALL_DATA_SUCCESS,
    UPDATE_HYDRATION_ALL_DATA_ERROR,
    RESET_HYDRATION,
    RESET_HYDRATION_UPDATE
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    hydrationData: null,
    hydrationLevelUpdating: false,
    hydrationLevelUpdateError: false,
    hydrationDataFetching: false,
    hydrationDataFetchFail: false,
    hydrationDataUpdating: false,
    hydrationDataUpdateError: false
};

const hydrationLevelUpdating = (state) => {
    return {
        ...state,
        hydrationLevelUpdating: true,
        hydrationLevelUpdateError: false
    };
};

const hydrationLevelUpdateFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        hydrationData: {
            ...state.hydrationData,
            ...action.response.data
        },
        hydrationLevelUpdating: false,
        hydrationLevelUpdateError: !isSuccess
    };
};

const hydrationDataFetching = (state) => {
    return {
        ...state,
        hydrationDataFetching: true,
        hydrationDataFetchFail: false
    };
};

const hydrationDataFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        hydrationData: action.dailyHydrationData,
        hydrationDataFetching: false,
        hydrationDataFetchFail: !isSuccess
    };
};

const hydrationDataUpdating = (state) => {
    return {
        ...state,
        hydrationDataUpdating: true,
        hydrationDataUpdateError: false
    };
};

const hydrationDataUpdateFinished = (state, action) => {
    return {
        ...state,
        hydrationData: {
            ...state.hydrationData,
            ...action.response.data
        },
        hydrationDataUpdating: false,
        hydrationDataUpdateError: false
    };
};

const hydrationDataUpdateError = (state) => {
    return {
        ...state,
        hydrationDataUpdating: false,
        hydrationDataUpdateError: true
    };
};

const resetHydration = () => {
    return INITIAL_STATE;
};

const resetHydrationUpdate = (state) => {
    return {
        ...state,
        hydrationLevelUpdating: false,
        hydrationLevelUpdateError: false
    };
};

export const isHydrationLevelUpdating = (state) => {
    return state.hydration.hydrationLevelUpdating;
};

export const isHydrationLevelUpdateError = (state) => {
    return state.hydration.hydrationLevelUpdateError;
};

export const isHydrationDataFetching = (state) => {
    return state.hydration.hydrationDataFetching;
};

export const isHydrationDataFetchFail = (state) => {
    return state.hydration.hydrationDataFetchFail;
};

export const getHydrationData = (state) => {
    return state.hydration.hydrationData;
};

export const isHydrationDataUpdating = (state) => {
    return state.hydration.hydrationDataUpdating;
};

export const isHydrationDataUpdateError = (state) => {
    return state.hydration.hydrationDataUpdateError;
};

const handlers = {
    [UPDATE_HYDRATION_LEVEL_UPDATING]: hydrationLevelUpdating,
    [UPDATE_HYDRATION_LEVEL_SUCCESS]: hydrationLevelUpdateFinished(true),
    [UPDATE_HYDRATION_LEVEL_ERROR]: hydrationLevelUpdateFinished(false),
    [FETCH_HYDRATION_DATA_FETCHING]: hydrationDataFetching,
    [FETCH_HYDRATION_DATA_SUCCESS]: hydrationDataFetchFinished(true),
    [FETCH_HYDRATION_DATA_FAIL]: hydrationDataFetchFinished(false),
    [UPDATE_HYDRATION_ALL_DATA_UPDATING]: hydrationDataUpdating,
    [UPDATE_HYDRATION_ALL_DATA_SUCCESS]: hydrationDataUpdateFinished,
    [UPDATE_HYDRATION_ALL_DATA_ERROR]: hydrationDataUpdateError,
    [RESET_HYDRATION]: resetHydration,
    [RESET_HYDRATION_UPDATE]: resetHydrationUpdate
};

export default function hydration(state = {}, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
